import { InferResult, sql } from 'kysely';
import {
  ActualityHqQueryBuilderParams,
  getActualityHqQueryBuilder,
} from '../actuality/cteQueryBuilders/actualityHqQueryBuilder';

export type ActualityCongestionRows = InferResult<
  ReturnType<typeof getActualityCongestions>
>;
export type ActualityCongestionRow = ActualityCongestionRows[number];
export type ActualityCongestionField = keyof ActualityCongestionRow;

export type ActualityCongestionsParams = ActualityHqQueryBuilderParams & {
  congestionThresholdSeconds: number;
  congestionDistance: number;
};

export function getActualityCongestions(params: ActualityCongestionsParams) {
  return getActualityHqQueryBuilder(params)
    .with(
      cte => cte('locationCongestions'),
      db =>
        db.selectFrom('hq').select(({ fn, selectFrom }) => [
          'hq.locationId as locationId',
          'hq.x as x',
          'hq.y as y',
          selectFrom('hq as t2')
            .select(({ fn }) => [fn.countAll().as('congestion')])
            .whereRef('hq.agentId', '<>', 't2.agentId')
            .where(({ between, fn }) =>
              between(
                fn('date_diff', [
                  sql.raw("'second'"),
                  sql.ref('t2.eventEndTime'),
                  sql.ref('hq.eventEndTime'),
                ]),
                0,
                params.congestionThresholdSeconds,
              ),
            )
            .where(
              sql<number>`ST_DISTANCE(
                ST_Point(${sql.ref('hq.x')},${sql.ref('hq.y')}), 
                ST_Point(${sql.ref('t2.x')},${sql.ref('t2.y')})) `,
              '<=',
              params.congestionDistance,
            )
            .as('congestion'),
        ]),
    )
    .selectFrom('locationCongestions')
    .select(({ fn }) => [
      'locationId',
      'x',
      'y',
      fn.sum<number>('congestion').as('congestion'),
    ])
    .groupBy(['locationId', 'x', 'y'])
    .having(({ fn }) => fn.sum<number>('congestion'), '>', 0);
}
